<template lang="html">
  <div class="account-list gap-24">
    <div class="account bgap-12" v-for="account in accounts.data" :key="account.email" >
      <div class="account-container flex-box">
        <div class="flex-box wrap">
          <SymbiumFormGroup
            klass="bgap-12 hgap-32-right"
            label="Email"
            :value="account.email"
            :locked="account.locked"
            :iconClass="account.locked ? 'si-lock_simple' : 'si-x'"
            :disabled="true"
            :onIconClick="() => openAccountRemoveModal(account)"
            inputSize="account-list-input-size"
          />
          <SymbiumFormGroup
            klass="bgap-12"
            label="Permissions"
            :value="account.role_name" 
            :locked="account.locked"
            :disabled="true"
            :iconClass="account.locked ? 'si-lock_simple' : ''"
            inputSize="account-list-input-size"
          />
        </div>
      </div>
    </div>
    <RemoveUserModal />
  </div>
</template>

<script>
import SymbiumFormGroup from 'src/components/common/form/SymbiumFormGroup.vue'
import RemoveUserModal from "src/components/common/modals/RemoveUserModal.vue"
import _ from "lodash"

export default {
  props: ["accounts", "availableRoles", "productName"],
  components: { SymbiumFormGroup, RemoveUserModal },
  computed: {
    roles() {
      return _.keys(this.availableRoles)
    }
  },
  methods: {
    openAccountRemoveModal(account) {
      if(account.locked) return;
      this.$modal.show('remove-user-modal', { email: account.email, productName: this.productName })
    }
  }
}
</script>

<style lang="scss">
.account-list {
  .account-container {
    justify-content: flex-start;

    .si-x {
      font-weight: 800;
      font-size: 10px;
      padding: 2px;
      color: var(--white);
      background: var(--gray-icons);
      border-radius: 50%;
    }
  }

  .account-list-input-size {
    width: calc(min(260px, 90vw)) !important;
  }
}

@media screen and (max-width: 768px) {
  .account-list {
    .email-section {
      width: 100%;
    }
  }
}
</style>
